const ApiStore = require("stores/abstract/ApiStore");
const router = require("services/router");
const env = require("services/env");
const axios = require("axios");
const {decodeObservable} = require("helpers/object");

class HourSlotsStore extends ApiStore {

    getNextAvailableDate() {
        return axios
            .post(router.route("api.checkout.hour-slots.next-available-date"), decodeObservable(this.constraints))
            .then(response => {
                if(typeof(response.data.date) !== 'undefined'){
                    return response.data.date;
                }
                return null;
            });
    }

}

const store = new HourSlotsStore(
	env.get("stores.hourSlots.collection", []),
	env.get("stores.hourSlots.constraints", {}),
	{},
	{endpoint: router.route("api.checkout.hour-slots.index")}
);

module.exports = store;



// WEBPACK FOOTER //
// ./resources/js/stores/HourSlotsStore.js